import React from 'react'
import PropTypes from 'prop-types'
import '../../assets/css/prints.css'
import NumberFormat from "react-number-format"
import moment from "moment"
import { groupByMultipleProperties } from "../../helpers/utils"
import { sumBy } from "lodash"

const ProductStockOutDetailToPrint = React.forwardRef((props, ref) => {
  const { item, isPrintForWarehouse } = props
  const { productStockOutProducts: products } = item
  let total = sumBy(products, product => {
    return product.quantity
  })
  let colspan = isPrintForWarehouse ? 4 : 3;

  let clothingSizes = products.map(product => {
    return {
      id: product.clothingSizeId,
      name: product.clothingSizeName,
      quantity: product.quantity,
    }
  })

  let clothingSizeGroups = groupByMultipleProperties(clothingSizes, [ "id", "name" ])
  let productGroups = groupByMultipleProperties(products, [ "purchaseOrderCode", "codeColor" ])

  return (<div ref={ ref }>
    <div className="print-container">
      <div className="print-content">
        <div className="header-section">
          <h2 className="header-title" style={ { fontSize: "1rem", color: "#000" } }>K&K GARMENT CO.,LTD</h2>
          <p className={ "card-title-desc text-center mb-0" } style={ { fontSize: "10pt", color: "#000" } }>No. 22 St
            02, Sangkat Chak
            Angrer Leu, Khan Mean Chey, Phnom Penh, Cambodia.</p>
          <hr className={ "m-0" }/>
          <h2 className="header-title" style={ { fontSize: "1.1rem", color: "#000" } }>ប័ណ្ណបញ្ចេញទំនិញ</h2>
          <div className="header-section1">
            <div className="header-col">
              { isPrintForWarehouse ?
                  <>
                    <p>Transfer From: <strong>{ item.fromName }</strong></p>
                    <p>Transfer To: <strong>{ item.toName }</strong></p>
                  </> : null
              }
            </div>
            <div className={ "mb-1 header-col text-center" }>
              <h2 className="header-title" style={ { fontSize: "1.1rem", color: "#000" } }>GOODS ISSUED NOTE</h2>
            </div>
            <div className="header-col align-items-end">
              <p>Serial No: <strong>{ item.serialNumber }</strong></p>
              <p>Date: <strong>{ moment(item.date)
                  .local()
                  .format("DD-MMM-YYYY") }</strong></p>
            </div>
          </div>
        </div>
        <table className="table-print">
          <thead>
          <tr>
            <th>#</th>
            <th>PO</th>
            <th>Code Color</th>
            {
              Object.keys(clothingSizeGroups).map((k, index) => {
                return Object.keys(clothingSizeGroups[k]).map((j, index) => {
                  return <th key={ index }>
                    { j }
                  </th>
                })
              })
            }
            {
              isPrintForWarehouse ?
                  <th>Location</th> : null
            }
            <th>Remark</th>
          </tr>
          </thead>
          <tbody>
          {
            Object.keys(productGroups).map((k, s) => {
              return Object.keys(productGroups[k]).map((j, index) => {
                let products = productGroups[k][j]
                return <tr key={ index }>
                  <td className={ "text-center" }>{ index + 1 }</td>
                  <td>{ k }</td>
                  <td>{ j }</td>
                  {
                    Object.keys(clothingSizeGroups).map((k1, index) => {
                      return Object.keys(clothingSizeGroups[k1]).map((j1, index) => {
                        let size = products.find(e => e.clothingSizeId === k1)
                        return <td key={ index } className={ 'text-center' }>
                          {
                              size &&
                              <NumberFormat
                                  value={ size.quantity }
                                  displayType="text"
                                  thousandSeparator={ true }
                                  fixedDecimalScale={ false }
                              />
                          }
                        </td>
                      })
                    })
                  }
                  {
                    isPrintForWarehouse ?
                        <td className={ "text-center" }>{ products?.at(0)?.locationName }</td> : null
                  }
                  <td></td>
                </tr>
              })
            })
          }
          <tr>
            <td colSpan={ Object.keys(clothingSizeGroups).length + colspan } className={ "text-right" }>
              <strong>TOTAL</strong>
            </td>
            <td className={ "text-center text-black" }><strong>{ total }</strong></td>
          </tr>
          </tbody>
        </table>
        <div className={ "m-0" }>
          <p>Title: <strong>{ item.name }</strong></p>
        </div>
        <div className="footer-section">
          <div className={ "p-2" } style={ { width: "100%", border: "1px", borderStyle: "solid" } }>
            <p className={ "text-center" }>រៀបចំដោយ/Prepared By </p>
            <div className="box-signature"></div>
            {/*<p><strong>{stockRequest.createdByUser}</strong></p>*/ }
          </div>
          <div className={ "p-2" } style={ { width: "100%", border: "1px", borderStyle: "solid" } }>
            <p className={ "text-center" }>ត្រួតពិនិត្យដោយ/Verified By </p>
            <div className="box-signature"></div>
            {/*<p><strong>{stockRequest.approvedByUser}</strong></p>*/ }
          </div>
          <div className={ "p-2" } style={ { width: "100%", border: "1px", borderStyle: "solid" } }>
            <p className={ "text-center" }>អនុញ្ញាត្តិដោយ/Verified By</p>
            <div className="box-signature"></div>
            {/*<p><strong>{stockRequest.createdByUser}</strong></p>*/ }
          </div>
          <div className={ "p-2" } style={ { width: "100%", border: "1px", borderStyle: "solid" } }>
            <p className={ "text-center" }>អ្នកទទួល/Received By </p>
            <div className="box-signature"></div>
            {/*<p><strong>{stockRequest.approvedByUser}</strong></p>*/ }
          </div>
        </div>
      </div>
    </div>
  </div>)
})

ProductStockOutDetailToPrint.displayName = 'ProductStockOutDetailToPrint'

ProductStockOutDetailToPrint.propTypes = {
  item: PropTypes.object,
  isPrintForWarehouse: PropTypes.bool.isRequired
}

export default ProductStockOutDetailToPrint